const testimonials = [
  {
    id: 0,
    name: 'Software Developer',
    title: 'Sept 2023 - Present ',
    org: 'Konciv',
    desc:
      'I am working as a Software Engineer at Konciv.  I work on a diverse range of tasks from software development to customer implementation, leveraging my wide skill set in Web Development',
  },

  {
    id: 1,
    name: 'JR. Associate MWP & Chatbot',
    title: 'July - Sept 2023',
    org: 'Celebal Technologies Private limited',
    desc:
      'Actively Involved in developing API and creating chatbots using Microsoft Bot Framework',
  },
  {
    id: 2,
    name: 'Backend Development Intern',
    title: 'Sept - Nov 2021',
    org: 'Cloutflow',
    desc:
      'Actively involved in building API from Scratch. Worked with various API like Shopify, Youtube, Gmail. ',
  },
  // {
  //   id: 3,
  //   name: 'Sayed',
  //   title: 'Marketing Head',
  //   org: 'Eleven Dawn',
  //   desc:
  //     'Really hard-working person. Deliver the work as promised. Planning to work more with this person.',
  // },
];
export default testimonials;
